var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.users,"loading":_vm.loading},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.$router.push(("/app/users-edit/" + (item.userId)))}}},[_c('v-icon',[_vm._v("mdi-pencil")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }